import { FaUserAlt as UserIcon } from 'react-icons/fa';

export default UserIcon;
